import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { RanksPage } from "@/features/gamification/components/ranks-page";
import { useI18n } from "@/providers/i18n-provider";

// Rangos de coleccionista (screen #27) — parte de gamificación del tab Journal.
function RanksRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Tus rangos`)}
      description={t(msg`Inicia sesión para ganar XP, subir de rango y reclamar recompensas.`)}
    >
      <RanksPage />
    </AuthPlaceholder>
  );
}

export const ranksRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/ranks",
  component: RanksRoutePage,
});
